import { Box, Text } from "rebass";
import { Label } from "./label";
import { maxWidth } from "styled-system";
import styled from "styled-components";

const Title = ({
  className,
  label,
  label_background,
  title,
  description,
  link
}) => {
  const showBackground = label_background === "Yes";
  return (
    <Box className={className} py={[4, 4, 4, 6]} px={[3, 3, 3, 4]}>
      <Inner mx="auto" maxWidth={[500, 500, 0]} textAlign="center">
        {label && (
          <Box mb={3}>
            <Label title={label} link={link} showBackground={showBackground} />
          </Box>
        )}
        <S_Text
          lineHeight={1}
          as="h2"
          fontFamily="medium"
          letterSpacing={1}
          fontSize={[4, 4, 5, 6]}
          my={0}
        >
          {title}
        </S_Text>
        {description && (
          <Text mt={[2, 3, 3, 3, 4]} fontSize={[2, 2, 3]} lineHeight={1.5}>
            {description}
          </Text>
        )}
      </Inner>
    </Box>
  );
};

const Inner = styled(Text)`
  ${maxWidth}
`;

const S_Text = styled(Text)`
  text-transform: uppercase;
`;

export { Title };
